import { Shadow, HStack, VStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Box, Skeleton } from 'native-base';
import React from 'react';

import { makeLoadingTable } from '../../../../../utils/makeLoadingTable';

export const Loading: React.FC = () => {
  const content = useBreakpointValue({
    base: (
      <VStack>
        {[...Array(6)].map((_, index) => (
          <VStack
            key={index}
            shadow={0.5}
            borderRadius={Spacing['inset.nano']}
            backgroundColor={Color['neutral.white']}
            paddingX={Spacing['inset.xs']}
            paddingY={Spacing['inset.sm']}
            marginBottom={Spacing['inset.xs']}
            justifyContent={'space-between'}
            width={'100%'}>
            <HStack
              marginBottom={Spacing['inset.quarck']}
              alignContent={'center'}
              alignItems={'center'}
              justifyContent={'space-between'}>
              <Skeleton
                borderRadius={Spacing['inline.nano']}
                height={18}
                width={'60%'}
                marginRight={Spacing['inset.nano']}
              />
              <Skeleton
                width={18}
                height={18}
                borderRadius={'full'}
                marginRight={Spacing['inline.nano']}
              />
            </HStack>
          </VStack>
        ))}
      </VStack>
    ),
    sm: (
      <VStack>
        <Shadow paddingY={Spacing['inset.md']} paddingX={Spacing['inline.xxxs']} level={1}>
          {makeLoadingTable({ numRows: 1, numCols: 5 })}
          {makeLoadingTable({ numRows: 2, numCols: 4 })}
          <VStack
            borderRadius={'sm'}
            px={Spacing['inline.sm']}
            py={Spacing['inset.sm']}
            justifyContent={'space-between'}
            width={'100%'}>
            {makeLoadingTable({ numRows: 1, numCols: 4 })}
            {makeLoadingTable({ numRows: 1, numCols: 5 })}
          </VStack>
        </Shadow>

        <Shadow paddingX={Spacing['inline.xxxs']} level={1}>
          {makeLoadingTable({ numRows: 1, numCols: 5 })}
          {makeLoadingTable({ numRows: 3, numCols: 4 })}
          <VStack
            borderRadius={'sm'}
            px={Spacing['inline.sm']}
            py={Spacing['inset.sm']}
            justifyContent={'space-between'}
            width={'100%'}>
            {makeLoadingTable({ numRows: 1, numCols: 4 })}
            {makeLoadingTable({ numRows: 1, numCols: 5 })}
          </VStack>
        </Shadow>
      </VStack>
    ),
    md: (
      <VStack>
        <Shadow paddingY={Spacing['inset.md']} paddingX={Spacing['inline.xxxs']} level={1}>
          {makeLoadingTable({ numRows: 2, numCols: 5 })}
          <VStack
            borderRadius={'sm'}
            px={Spacing['inline.sm']}
            py={Spacing['inset.sm']}
            justifyContent={'space-between'}
            width={'100%'}>
            {makeLoadingTable({ numRows: 2, numCols: 8 })}
          </VStack>
          <Box paddingX={Spacing['inline.xxxs']} />
        </Shadow>

        <Shadow paddingX={Spacing['inline.xxxs']} level={1}>
          {makeLoadingTable({ numRows: 2, numCols: 5 })}
          <VStack
            borderRadius={'sm'}
            px={Spacing['inline.sm']}
            py={Spacing['inset.sm']}
            justifyContent={'space-between'}
            width={'100%'}>
            {makeLoadingTable({ numRows: 3, numCols: 8 })}
          </VStack>
          <Box paddingX={Spacing['inline.xxxs']} />
        </Shadow>
      </VStack>
    ),
  });

  return content;
};
